import React, { FunctionComponent } from "react";
import { strings } from "../../../../localization/LocalizedStrings";
import styles from "../../subscriptions/DocumentationSubscriptions/styles.module.scss";

export const DocumentationPurchases: FunctionComponent = () => {
  return (
    <div>
      <section id={"title"} />
      <h1>{strings.doc_purchases.title}</h1>
      <p>{strings.doc_purchases.description_1}</p>
      <ul className={styles.indentedText}>
        <li>{strings.doc_purchases.limit_albums}</li>
        <li>{strings.doc_purchases.limit_collections}</li>
        <li>{strings.doc_purchases.limit_shelvings}</li>
        <li>{strings.doc_purchases.limit_artists}</li>
        <li>{strings.doc_purchases.limit_labels}</li>
        <li>{strings.doc_purchases.limit_album_formats}</li>
        <li>{strings.doc_purchases.limit_album_types}</li>
        <li>{strings.doc_purchases.limit_tags}</li>
        <li>{strings.doc_purchases.limit_stores}</li>
        <li>{strings.doc_purchases.limit_sell_values}</li>
        <li>{strings.doc_purchases.limit_exchange_rates}</li>
      </ul>
      <p>{strings.doc_purchases.description_2}</p>
    </div>
  );
};
